export default __webpack_public_path__ + "static/media/BOOST.e690b4ee.svg";